import React from 'react';
import { TypingParagraphe } from '../../utils';
import { Images } from '../../constants';
import { formatInterviewScrollHeader, getChatTimestampHoverTitle } from '../../utils/formatDate';
import { getTenantInitial, getTenantName } from '../../utils/brandingStyles';

// Définition des types pour les props
interface QuestionProps {
    index: number;
    currentIndex: number;
    questionText: string;
    questionAndResponseLength: number;
    setCurrentIndex: (index: number) => void;
    useModernLayout?: boolean;
    senderName?: string;
    timestamp?: string;
    actions?: React.ReactNode;
}

const Question: React.FC<QuestionProps> = ({
    index,
    currentIndex,
    questionText,
    questionAndResponseLength,
    setCurrentIndex,
    useModernLayout = false,
    senderName = getTenantName(),
    timestamp,
    actions
}) => {

    const timeLabel = timestamp ? formatInterviewScrollHeader(timestamp) : '';
    const timeHoverTitle = timestamp ? getChatTimestampHoverTitle(timestamp, new Date()) : undefined;

    if (useModernLayout) {
        return (
            <div className="turn ai-turn">
                <div className="t-avatar t-ai">{getTenantInitial()}</div>
                <div className="t-body">
                    <div className="t-sender s-ai">
                        {senderName}
                        {timeLabel && (
                            <span className="t-time" title={timeHoverTitle}>
                                {timeLabel}
                            </span>
                        )}
                    </div>
                    <div className="t-text">
                        {index === questionAndResponseLength - 1 ? (
                            <TypingParagraphe
                                text={questionText}
                                time={15}
                                className="text-pre-wrap"
                                onIndexChange={setCurrentIndex}
                            />
                        ) : (
                            <span className="text-pre-wrap">{questionText}</span>
                        )}
                    </div>
                    {actions && <div className="ai-actions">{actions}</div>}
                </div>
            </div>
        );
    }

    return (
        <>
            <img src={Images.logov1} alt="Logo" className='imgFluid' />
            <p className="fs-6 ps-3 text-light fw-lighter mt-1 costom-control">
                {index === questionAndResponseLength - 1 ? (
                    <TypingParagraphe
                        text={questionText}
                        time={15}
                        className="fs-6 text-pre-wrap "
                        onIndexChange={setCurrentIndex}
                    />
                ) : (
                    <span className='text-pre-wrap'>{questionText}</span>
                )}
            </p>
        </>
    );
};

export default Question;
